import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { Skeleton } from '@/shadcn/components/Skeleton';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var AddFilderIcon = function AddFilderIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_6765_363)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.20626 4.02016e-05C6.53177 -0.000262685 6.81877 -0.000529712 7.09753 0.0663936C7.34242 0.125186 7.57652 0.222156 7.79126 0.353745C8.03569 0.503532 8.23844 0.706661 8.46839 0.937045L9.13137 1.60008L12.6708 1.60008C13.0926 1.60007 13.4564 1.60005 13.756 1.62454C14.0723 1.65038 14.3869 1.70743 14.6896 1.86167C15.1412 2.09176 15.5083 2.45891 15.7384 2.91051C15.8926 3.21321 15.9497 3.52778 15.9755 3.84406C16 4.14371 16 4.50752 16 4.92923V9.47093C16 9.89264 16 10.2564 15.9755 10.5561C15.9497 10.8724 15.8926 11.187 15.7384 11.4897C15.5083 11.9412 15.1412 12.3084 14.6896 12.5385C14.3869 12.6927 14.0723 12.7498 13.756 12.7756C13.4564 12.8001 13.0925 12.8001 12.6708 12.8001H3.32909C2.90741 12.8001 2.54361 12.8001 2.24398 12.7756C1.9277 12.7498 1.61313 12.6927 1.31043 12.5385C0.858837 12.3084 0.491683 11.9412 0.261587 11.4897C0.107352 11.187 0.050299 10.8724 0.0244582 10.5561C-2.35721e-05 10.2565 -1.23796e-05 9.89264 5.94402e-07 9.47095V3.32921C-1.23796e-05 2.90752 -2.35721e-05 2.5437 0.0244582 2.24406C0.050299 1.92778 0.107352 1.61321 0.261587 1.3105C0.491683 0.858915 0.858836 0.491762 1.31043 0.261666C1.61313 0.10743 1.9277 0.0503777 2.24398 0.0245369C2.54364 5.39914e-05 2.90745 6.63324e-05 3.32917 8.06374e-05L6.20626 4.02016e-05ZM8.8 5.6001C8.8 5.15827 8.44183 4.8001 8 4.8001C7.55817 4.8001 7.2 5.15827 7.2 5.6001V6.4001H6.4C5.95817 6.4001 5.6 6.75827 5.6 7.2001C5.6 7.64192 5.95817 8.0001 6.4 8.0001H7.2V8.8001C7.2 9.24192 7.55817 9.6001 8 9.6001C8.44183 9.6001 8.8 9.24192 8.8 8.8001V8.0001H9.6C10.0418 8.0001 10.4 7.64192 10.4 7.2001C10.4 6.75827 10.0418 6.4001 9.6 6.4001H8.8V5.6001Z",
        fill: "#12131A"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6765_363",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "12.8001",
          fill: "white"
        })
      })
    })]
  }));
};

AddFilderIcon.defaultProps = {
  width: "16",
  height: "13",
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DownloadFileIcon = function DownloadFileIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6765_356)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.0889 10.3111C12.0889 9.91838 11.7705 9.60001 11.3778 9.60001C10.985 9.60001 10.6667 9.91838 10.6667 10.3111V12.861L10.4584 12.6527C10.1807 12.375 9.73043 12.375 9.45273 12.6527C9.17502 12.9304 9.17502 13.3807 9.45273 13.6584L10.8749 15.0806C11.1527 15.3583 11.6029 15.3583 11.8806 15.0806L13.3028 13.6584C13.5805 13.3807 13.5805 12.9304 13.3028 12.6527C13.0251 12.375 12.5749 12.375 12.2972 12.6527L12.0889 12.861V10.3111Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.711105 3.76889C0.711105 2.57411 0.711105 1.97673 0.943625 1.52038C1.14815 1.11897 1.47451 0.79261 1.87593 0.58808C2.33227 0.35556 2.92966 0.35556 4.12444 0.35556H6.54221C6.74134 0.35556 6.84091 0.35556 6.91697 0.394314C6.98387 0.428402 7.03826 0.482795 7.07235 0.549697C7.1111 0.625754 7.1111 0.725319 7.1111 0.924449V2.48889C7.1111 4.05984 8.3846 5.33334 9.95555 5.33334H11.52C11.7191 5.33334 11.8187 5.33334 11.8947 5.37209C11.9616 5.40618 12.016 5.46057 12.0501 5.52747C12.0889 5.60353 12.0889 5.7031 12.0889 5.90223V7.60889C12.0889 7.80802 12.0889 7.90759 12.0501 7.98364C12.016 8.05055 11.9616 8.10494 11.8947 8.13903C11.8187 8.17778 11.7191 8.17778 11.52 8.17778H11.3778C9.02136 8.17778 7.1111 10.088 7.1111 12.4444V14.0089C7.1111 14.208 7.1111 14.3076 7.07235 14.3836C7.03826 14.4505 6.98387 14.5049 6.91697 14.539C6.84091 14.5778 6.74134 14.5778 6.54221 14.5778H4.12444C2.92966 14.5778 2.33227 14.5778 1.87593 14.3453C1.47451 14.1407 1.14815 13.8144 0.943625 13.413C0.711105 12.9566 0.711105 12.3592 0.711105 11.1644V3.76889Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.53334 0.858392C8.53334 0.580685 8.75847 0.35556 9.03617 0.35556C9.16953 0.35556 9.29743 0.408537 9.39173 0.502836L11.9416 3.05273C12.0359 3.14703 12.0889 3.27492 12.0889 3.40828C12.0889 3.68599 11.8638 3.91112 11.5861 3.91112H9.95556C9.17009 3.91112 8.53334 3.27436 8.53334 2.48889V0.858392Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6765_356",
        children: /*#__PURE__*/_jsx("rect", {
          width: "13.8667",
          height: "16",
          fill: "white"
        })
      })
    })]
  }));
};

DownloadFileIcon.defaultProps = {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CircleSquare = function CircleSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6765_329)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M5.33333 12.8889C5.33333 12.6434 5.53286 12.4459 5.77786 12.4308C9.35113 12.2104 12.2104 9.35114 12.4308 5.77787C12.4459 5.53287 12.6434 5.33334 12.8889 5.33334H14.2222C15.2041 5.33334 16 6.12928 16 7.11112V14.2222C16 15.2041 15.2041 16 14.2222 16H7.11111C6.12927 16 5.33333 15.2041 5.33333 14.2222V12.8889Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.6667 5.33333C10.6667 8.27885 8.27885 10.6667 5.33333 10.6667C2.38781 10.6667 0 8.27885 0 5.33333C0 2.38781 2.38781 0 5.33333 0C8.27885 0 10.6667 2.38781 10.6667 5.33333Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6765_329",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  }));
};

CircleSquare.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const Header = _ref => {
  let {
    className = '',
    widgets,
    filters,
    isLoaded
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    className: clsx('py-8', styles.container, className),
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsxs("a", {
        href: "#newest",
        className: clsx('mx-auto mb-4 flex w-fit items-center rounded-full px-4 py-2 text-sm', styles.badge),
        children: [/*#__PURE__*/_jsx("span", {
          className: "mr-1 font-semibold",
          children: "New Templates"
        }), "| See Latest", /*#__PURE__*/_jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          className: "lucide lucide-arrow-right ml-2 inline size-4",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M5 12h14"
          }), /*#__PURE__*/_jsx("path", {
            d: "m12 5 7 7-7 7"
          })]
        })]
      }), /*#__PURE__*/_jsx("h1", {
        className: clsx('my-4 mb-6 mx-auto text-center text-3xl font-bold lg:text-5xl', styles.header),
        children: "Explore our full template library of dashboards & calculators."
      }), /*#__PURE__*/_jsx("p", {
        className: "mx-auto mb-6 max-w-2xl text-center text-muted-foreground lg:text-xl",
        children: "All templates have been throughly researched to include expert recommended metrics and visualizations. Preview widgets with free downloadable spreadsheet."
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-6 lg:mt-8",
        children: /*#__PURE__*/_jsxs("ul", {
          className: "flex flex-wrap justify-center gap-4 text-sm lg:text-base",
          children: [/*#__PURE__*/_jsxs("li", {
            className: "flex items-center gap-2 whitespace-nowrap",
            children: [/*#__PURE__*/_jsx(AddFilderIcon, {}), widgets.length, " Available Templates"]
          }), /*#__PURE__*/_jsxs("li", {
            className: "flex items-center gap-2 whitespace-nowrap",
            children: [/*#__PURE__*/_jsx(DownloadFileIcon, {}), "Downloadable Speadsheet"]
          }), /*#__PURE__*/_jsxs("li", {
            className: "flex items-center gap-2 whitespace-nowrap",
            children: [/*#__PURE__*/_jsx(CircleSquare, {}), "Ready to customize"]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex gap-4 justify-center mt-6 md:mt-8",
        children: !isLoaded ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: "h-9 w-[100px]"
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "h-9 w-[100px]"
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "h-9 w-[100px]"
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "h-9 w-[100px]"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("a", {
            href: `#popular`,
            className: "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2 capitalize",
            children: "Popular"
          }), /*#__PURE__*/_jsx("a", {
            href: `#newest`,
            className: "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2 capitalize",
            children: "Newest"
          }), filters === null || filters === void 0 ? void 0 : filters.map((tag, index) => /*#__PURE__*/_jsx("a", {
            href: `#${tag.name}`,
            className: "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2 capitalize",
            children: tag.name
          }, `tag-${tag.name}-${index}`))]
        })
      })]
    })
  });
};
export default Header;